'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/server.js
// module id = ./node_modules/react-dom/server.js
// module chunks = 11056403903869698000